import { withRequest } from "components/hoc/withRequest";
import { DoughnutChart } from "components/common";

export const NumberOfWalletsByUser = ({ width }) => {
  const Component = withRequest(DoughnutChart, { apiMethodName: "getNumberOfWalletsByUser", width });

  return <Component />;
};
